<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <div class="write-txt">
          <p class="write-title">演讲主题<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="addObj.title"></textarea>
            <span>最多输入30个以内的中文</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">每日一词<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="addObj.keyword"></textarea>
            <span>最多输入90个以内的中英文</span>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.language" placeholder="请选择">
              <el-option
                v-for="item in typelist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>请选择</span>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">排序<span>*</span></p>
          <div class="write-text">
            <input type="number" v-model="addObj.sort">
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加每日一词</p>
          </div>
          <div class="btnBox">
            <button class="btn btn-add" @click="updown">下载模板</button>
            <el-upload
              class="upload-demo btn btn-import"
              :action="url+'/admin/DailyWord/importDailyWord'"
              :headers="{'userToken':token}"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              accept=".xls, .xlsx"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">导入</el-button>
            </el-upload>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.keyword">{{item.keyword}}</p>
              <p :title="item.language==1?'中文':'英文'">{{item.language==1?'中文':'英文'}}</p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="修改" class="btn btn-revise" @click="buildSub(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLexiconList,saveLexicon,delLexicon,getLexiconDetail  } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'9',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'演讲主题'},
        {id:3,title:'每日一词'},
        {id:4,title:'类型'},
        {id:5,title:'排序'},
        {id:6,title:'添加时间'},
        {id:7,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        title:'',
        keyword:'',
        language:1,
        sort:'',
      },
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/词库导入表.xlsx',
      typelist:[
        {id:1,title:'中文'},
        {id:2,title:'英文'},
      ]
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getLexiconList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getLexiconDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj =  response.data;
          that.addType = 'edit';
          console.log(that.addObj.sort)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delLexicon({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请输入主题！');
        return false;
      }
      if(this.addObj.keyword == ''){
        that.$message('请输入每日一词！');
        return false;
      }
      try {
        const response = await saveLexicon(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        chinese:'',
        english:'',
      }
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.loading = false;
        that.getList();
      } else {
        that.$message(response.msg);
      }
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 7 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/word/index.vue